import { AuthType } from './Company';
import { StorageClass } from './StorageType.enum';

export enum GlobalAgentOptionsTypes {
  Backup = 'Backup',
  RMM = 'RMM',
  RA = 'RA',
  Uninstall = 'Uninstall'
}

export type AgentOptions = {
  id?: string;
  isDefault: boolean;
  profileUpdate?: string;
  settingsCompanies: string[];
  backupValues: BackupOptionsValues;
  rmmValues: RMMOptionsValues;
  connectValues: ConnectOptionsValues;
};

export type BackupOptionsValues = {
  allowStandardIA: boolean;
  defaultS3StorageClass: StorageClass;
  defaultUseStandardIA: boolean;
  defaultUseOneZoneIA: boolean;
  defaultUseIntelligentTier: boolean;
  defaultUseGlacier: boolean;
  defaultUseGlacierDeepArchive: boolean;
  allowS3Acceleration: boolean;
  defaultUseS3Acceleration: boolean;
  allowSSE: boolean;
  defaultUseSSE: boolean;
  allowVSS: boolean;
  defaultUseVSS: boolean;
  allowBackupPlanEdit: boolean;
  allowRestoreWizardOpening: boolean;
  allowConsole: boolean;
  allowFileSystemAccount: boolean;
  allowEncryption: boolean;
  allowCompression: boolean;
  defaultUseCompression: boolean;
  showWinAuth: boolean;
  showWinAuthLess: boolean;
  showPasswordAuth: boolean;
  defaultAuthType: AuthType;
  allowRestoreToAzure: boolean;
  allowRestoreToEC2: boolean;
  allowFilenameEncryption: boolean;
  allowRemoteConnection: boolean;
  allowRAToBootable: boolean;
  allowStorageMenuItemDelete: boolean;
  allowPrePostActions: boolean;
  allowSendLogs: boolean;
  net10RequiresUserAuth?: boolean;
};

export type RMMOptionsValues = {
  readOnly: boolean;
  allowPowerShell: boolean;
  hideTrayIcon: boolean;
};

export type ConnectOptionsValues = {
  allowRAUnattendedAccess: boolean;
  allowRemoteConnection: boolean;
};

export type UninstallAgentValues = {
  withPassword: boolean;
  password: string;
};
